import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-care-popup',
  templateUrl: './care-popup.component.html',
  styleUrls: ['./care-popup.component.scss']
})
export class CarePopupComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<CarePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  ngOnInit(): void {
  }
  close(): void {
    this.dialogRef.close(true);
  }

}
